import { Upload, canStoreURLs } from 'tus-js-client';
import vimeoaxios from '../../vimeoaxios';
import { requestVimeoToken } from '../utils/smartutils';

export async function getVimeoToken() {
  let token = '';
  await requestVimeoToken()
    .then((res) => {
      token = res.headers['vimeo-token'];
    })
    .catch((error) => {
      console.error(error);
      token = null;
    });
  return token;
}

export async function createVimeoVideoUpload(file) {
  const vimeoToken = await getVimeoToken();
  let upload = false;
  if (vimeoToken) {
    const upLoadData = {
      upload: {
        approach: 'tus',
        size: `${file.size}`,
      },
    };

    const customHeaders = {
      'Content-Type': 'application/json',
      Accept: 'application/vnd.vimeo.*+json;version=3.4',
    };

    await vimeoaxios(vimeoToken, customHeaders)
      .post('/me/videos', upLoadData)
      .then((res) => {
        upload = res.data;
      })
      .catch((error) => {
        console.error(error);
      });
  }
  return upload;
}

export async function createTusUploadObject(file, tusConfig) {
  const tusUpload = new Upload(file, tusConfig);
  tusUpload.findPreviousUploads().then((res) => {
    console.log('createTusUploadObject -> res', res);
  });
  return tusUpload;
}

export async function resumeUploads() {
  Upload.resumeUploads();
}

export function canStoreUrlsFunc() {
  console.log('canStoreUrls -> canStoreUrls', canStoreURLs);
  Upload.findPreviousUploads().then((res) => {
    console.log('canStoreUrlsFunc -> res', res);
  });
}
